import { common } from '@mui/material/colors';

import { neutrals } from '@toolbox/style/theme/common/ThemeProvider/colors';

import type { Breakpoints, Theme, SxProps, Palette } from '@mui/material';
import type { Spacing } from '@mui/system/createTheme/createSpacing';

const buttonSize = 48;
const buttonMargin = buttonSize + 16;

export const boxSx = (
  selected: boolean,
  isPrevVisible: boolean,
  isSticky: boolean,
  sx: SxProps<Theme> = [],
  isNextVisible?: boolean,
  isDisabled = false,
): SxProps<Theme> => {
  let selectedStyles = {};
  if (selected && isSticky) {
    selectedStyles = {
      position: 'sticky',
      left: isPrevVisible ? buttonMargin : 0,
      right: isNextVisible ? buttonMargin : 0,
      zIndex: 1,
    };
  }

  return [
    ({
      palette,
      spacing,
      breakpoints,
    }: {
      palette: Palette;
      spacing: Spacing;
      breakpoints: Breakpoints;
    }) => ({
      flex: 1,
      textAlign: 'center',
      color: selected ? common.white : palette.primary.main,
      background: selected ? palette.primary.main : neutrals.contrastText,
      padding: spacing(2, 1),
      '& p': {
        color: selected ? common.white : palette.primary.main,
      },
      cursor: 'pointer',
      minWidth: 140,
      [breakpoints.down('md')]: {
        minWidth: 120,
      },
      [breakpoints.down('sm')]: {
        minWidth: 110,
      },
    }),
    isDisabled ? { opacity: 0.6 } : {},
    selectedStyles,
    ...(Array.isArray(sx) ? sx : [sx]),
  ];
};

export const rootSx = (
  isPrevVisible: boolean,
  isDisabled: boolean,
  sx: SxProps<Theme> = [],
): SxProps<Theme> => {
  return [
    ({ spacing }: { spacing: Spacing }) => ({
      position: 'relative',
      display: 'flex',
      width: '100%',
      overflow: 'auto',
      padding: spacing(2, 0),
      gap: 1,
    }),
    isDisabled ? { opacity: 0.6, pointerEvents: 'none' } : {},
    ({ palette }: { palette: Palette }) => ({
      '& .carousel div:last-child div': {
        marginRight: 1,
        '&:last-child': {
          marginRight: 0,
        },
      },
      '& .carousel': {
        paddingLeft: isPrevVisible ? `-${buttonMargin}px` : 0,
      },
      '& .carousel > [data-arrow=right]': {
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        display: 'flex',
        alignItems: 'center',
        background: palette.common.white,
        cursor: 'pointer',
        zIndex: 2,
      },
      '& .carousel > [data-arrow=left]': {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        background: palette.common.white,
        cursor: 'pointer',
        zIndex: 2,
      },
    }),
    ...(Array.isArray(sx) ? sx : [sx]),
  ];
};

export const arrowButtonSx: SxProps<Theme> = (theme: Theme) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: buttonSize,
  height: buttonSize,
  margin: 1,
  borderRadius: '50%',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  background: neutrals.contrastText,
  color: theme.palette.primary.main,
  transition: 'all .3s ease',
  '&:hover': {
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)',
  },
  '& svg': {
    width: 20,
    height: 10,
  },
});
